// @material-ui/icons
import Flight from "@material-ui/icons/Flight";
import Settlement from "@material-ui/icons/Style";
import Settings from "@material-ui/icons/SettingsApplications";
import Passenger from "@material-ui/icons/AirlineSeatReclineExtra";
import Email from "@material-ui/icons/Email";
import Audit from "@material-ui/icons/TrackChanges";
import AirlineRouteIcon from "@material-ui/icons/Flight";
import PscSettings from "@material-ui/icons/SettingsBackupRestore";
import Landing from "@material-ui/icons/FlightLandOutlined";

import MainLandingPage from "../layouts/Landing/RegionalLanding/landing";

import NotFound from "views/NotFound/Index.jsx";

import AirlinesPassengerPage from "views/AirlinesPassenger/Index.jsx";
import AirlinePaymentPage from "views/AirlinePayment/Index.jsx";
import SettlementPage from "views/Settlement/Index.jsx";
import SettingsPage from "views/Settings/Index.jsx";
import EmailSettings from "views/EmailSettings/Index.jsx";
import PscSettingsTable from "views/PscSettings/Index.jsx";
import AirlineRouteSetting from "views/AirlineRouteSettings";
import BillablePscSettings from "views/BillablePscSettings/Index.jsx"
import HelpIcon from "@material-ui/icons/HelpOutline"
import HelpCenter from "../views/HelpCenter";

const dashboardRoutes = [
  {
    path: "/main-landing",
    sidebarName: "Main Landing",
    navbarName: "Main Landing",
    icon: Landing,
    component: MainLandingPage,
    subMenu: [],
  },
  {
    path: "/app/passenger-data",
    sidebarName: "Passenger Data",
    navbarName: "Airline Passenger Data",
    icon: Passenger,
    subMenu: [],
    component: AirlinesPassengerPage
  },
  {
    path: "/app/airline-payment",
    sidebarName: "Airline Payment",
    navbarName: "Airline Payment Report",
    icon: Flight,
    subMenu: [],
    component: AirlinePaymentPage
  },
  {
    path: "/app/psc-settlement",
    sidebarName: " PSC Settlement",
    navbarName: "PSC Settlement",
    icon: Settlement,
    subMenu: [],
    component: SettlementPage
  },
  {
    path: "/app/settings",
    sidebarName: "Settings",
    navbarName: "Settings",
    subMenu: [
      {
        path: "/app/settings",
        sidebarName: "Re-order Level",
        navbarName: "Re-order Level",
        component: SettingsPage
      },
      {
        path: "/app/pscSettings",
        sidebarName: "PSC Settings",
        navbarName: "PSC Settings",
        icon: PscSettings,
        component: PscSettingsTable
      },
      {
        path: "/app/emailSettings",
        sidebarName: "Email Settings",
        navbarName: "Email Settings",
        icon: Email,
        component: EmailSettings
      },
      {
        path: "/app/airlineRouteSettings",
        sidebarName: "Airline Routes",
        navbarName: "Airline Routes Settings",
        icon: AirlineRouteIcon,
        component: AirlineRouteSetting
      },
      {
        path: "/app/billableSettings",
        sidebarName: "Billable Passenger",
        navbarName: "Billable Passenger Settings",
        icon: AirlineRouteIcon,
        component: BillablePscSettings,
        
      },
    ],
    icon: Settings,
    component: SettingsPage
  },
  {
    path: "/app/pscSettings",
    sidebarName: "PSC Settings",
    navbarName: "PSC Settings",
    icon: PscSettings,
    isNotVisible: true,
    component: PscSettingsTable,
    subMenu: [],
    
  },
  {
    path: "/app/emailSettings",
    sidebarName: "Email Settings",
    navbarName: "Email Settings",
    icon: Email,
    isNotVisible: true,
    component: EmailSettings,
    subMenu: [],
    
  },
  {
    path: "/app/airlineRouteSettings",
    sidebarName: "Airline Routes",
    navbarName: "Airline Routes Settings",
    icon: AirlineRouteIcon,
    isNotVisible: true,
    component: AirlineRouteSetting,
    subMenu: []
  },
  {
    path: "/app/billableSettings",
    sidebarName: "Billable Passenger",
    navbarName: "Billable Passenger Settings",
    icon: AirlineRouteIcon,
    component: BillablePscSettings,
    isNotVisible: true,
    subMenu: [],
  },
  {
    path: "/app/help-center",
    sidebarName: "Help Center",
    navbarName: "Help Center",
    icon: HelpIcon,
    component: HelpCenter,
    subMenu: []
  },
  {
    isNotVisible: true,
    path: "**",
    sidebarName: "Not found",
    navbarName: "Not Found",
    icon: Audit,
    subMenu: [],
    component: NotFound,
    
  }
];

export default dashboardRoutes;



// WEBPACK FOOTER //
// ./src/routes/HQ-supervisor.js